import React from 'react';
import {IconProps} from './types';

export const Minus = ({width, height, color}:IconProps) => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke={color}/>
            <path d="M12 17V22.6C12 23.9255 13.0745 25 14.4 25C14.7314 25 15 25.2686 15 25.6V28L19.7625 25.1425C19.9179 25.0493 20.0957 25 20.277 25H24C26.2091 25 28 23.2091 28 21V17C28 14.7909 26.2091 13 24 13H16C13.7909 13 12 14.7909 12 17Z" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="18" cy="19" r="1" fill={color}/>
            <circle cx="22" cy="19" r="1" fill={color}/>
        </svg>
    );
};
